export const getClientHost: () => string | undefined = () => {
    const currentUrl = window.location.href;
    const matchResult = currentUrl.match(/^(https?:\/\/[^/]+)/);

    if (matchResult && matchResult[1].includes('localhost:3000')) {
        return 'http://localhost/center_api/';
    }

    return matchResult ? `${matchResult[1]}/center_api/` : undefined;
};
